import React from "react";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import currencyCodes from "currency-codes";

const FieldFormatSelection = ({ type, value, onChange, label = "Format" }) => {
  let options = [];
  let labelKey = ["name"];
  let valueKey = "id";
  switch (type) {
    case "number":
      options = [
        { id: "dollar", name: "Dollar" },
        { id: "rupee", name: "Rupee" },
        { id: "currency", name: "Currency" },
        { id: "currency_format", name: "Currency Format" },
        { id: "percentage", name: "Percentage" },
        { id: "rounded", name: "Rounded (No decimals)" },
        {
          id: "international_numeral_format",
          name: "International Numeral Format"
        },
        {
          id: "international_numeral_m_format",
          name: "International Numeral Million Format"
        },
        {
          id: "international_numeral_b_format",
          name: "International Numeral Billion Format"
        },
        { id: "indian_numeral_format", name: "Indian Numeral Format" },
        { id: "indian_numeral_k_format", name: "Indian Numeral Thousand Format" },
        { id: "indian_numeral_l_format", name: "Indian Numeral Lakhs Format" },
        { id: "indian_numeral_cr_format", name: "Indian Numeral Crores Format" }
      ];
      break;
    case "date":
    case "date-range":
      options = [
        { id: "DD-MM-YYYY", name: "DD-MM-YYYY" },
        { id: "DD-MM-YY", name: "DD-MM-YY" },
        { id: "MM-DD-YYYY", name: "MM-DD-YYYY" },
        { id: "MM-DD-YY", name: "MM-DD-YY" },
        { id: "YYYY-MM-DD", name: "YYYY-MM-DD" },
        { id: "YY-MM-DD", name: "YY-MM-DD" },
        { id: "DD-MON-YYYY", name: "DD-Mon-YYYY" },
        { id: "DD-MON-YY", name: "DD-Mon-YY" },
        { id: "DD MON", name: "DD Mon" },
        { id: "MON DD YY", name: "Mon DD YY" },
        { id: "MON DD YYYY", name: "Mon DD YYYY" },
        { id: "MON YY", name: "Mon YY" },
        { id: "MON YYYY", name: "Mon YYYY" },
        { id: "YYYY MON", name: "YYYY Mon" },
        { id: "YY MON", name: "YY Mon" },
        { id: "Ago", name: "Ago" }
      ];
      break;
    case "time":
      options = [
        { id: "HH:MM", name: "HH:MM" },
        { id: "HH:MM AM/PM", name: "HH:MM AM/PM" },
        { id: "HH:MM:SS", name: "HH:MM:SS" },
        { id: "HH:MM:SS AM/PM", name: "HH:MM:SS AM/PM" },
        { id: "Ago", name: "Ago" }
      ];
      break;
    case "currency":
      options = currencyCodes.data;
      valueKey = "code";
      labelKey = ["code", "currency"];
      break;
    case "datetime":
      options = [
        { id: "DD-MM-YYYY HH:MM", name: "DD-MM-YYYY HH:MM" },
        { id: "DD-MM-YYYY HH:MM AM/PM", name: "DD-MM-YYYY HH:MM AM/PM" },
        { id: "DD-MM-YY HH:MM", name: "DD-MM-YY HH:MM" },
        { id: "DD-MM-YY HH:MM AM/PM", name: "DD-MM-YY HH:MM AM/PM" },
        { id: "DD MON YY HH:MM", name: "DD Mon YY HH:MM" },
        { id: "DD MON YY HH:MM AM/PM", name: "DD Mon YY HH:MM AM/PM" },
        { id: "DD-MON-YY HH:MM", name: "DD-Mon-YY HH:MM" },
        { id: "DD-MON-YY HH:MM AM/PM", name: "DD-Mon-YY HH:MM AM/PM" },
        { id: "DD-MON-YYYY HH:MM", name: "DD-Mon-YYYY HH:MM" },
        { id: "DD-MON-YYYY HH:MM AM/PM", name: "DD-Mon-YYYY HH:MM AM/PM" },
        { id: "MON YY HH:MM", name: "Mon YY HH:MM" },
        { id: "MON YY HH:MM AM/PM", name: "Mon YY HH:MM AM/PM" },
        { id: "MON YYYY HH:MM", name: "Mon YYYY HH:MM" },
        { id: "MON YYYY HH:MM AM/PM", name: "Mon YYYY HH:MM AM/PM" },
        { id: "DD MON HH:MM", name: "DD Mon HH:MM" },
        { id: "DD MON HH:MM AM/PM", name: "DD Mon HH:MM AM/PM" },
        { id: "Ago", name: "Ago" }
      ];

      break;
    default:
      break;
  }
  return (
    <SingleSelectBox
      selectedData={value}
      labelKey={labelKey}
      valueKey={valueKey}
      options={options}
      onChange={(obj) => onChange(obj[valueKey])}
      label={label}
      isSearch={true}
    />
  );
};

export default FieldFormatSelection;
